/*
=========================================================
Muse - Vue Ant Design Dashboard - v1.0.0
=========================================================

Product Page: https://www.creative-tim.com/product/vue-ant-design-dashboard
Copyright 2021 Creative Tim (https://www.creative-tim.com)
Coded by Creative Tim

=========================================================
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. 
*/

import Vue from 'vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue'
import DefaultLayout from './layouts/Default.vue'
import DashboardLayout from './layouts/Dashboard.vue'
import DashboardRTLLayout from './layouts/DashboardRTL.vue'
import router from './router'
import { auth } from "./firebase";
import EasyCamera from 'easy-vue-camera';

// import './plugins/click-away'

import './scss/app.scss';

import store from './store'
import './registerServiceWorker'

Vue.use(Antd);

Vue.config.productionTip = false


Vue.use(EasyCamera);

// Adding template layouts to the vue components.
Vue.component("layout-default", DefaultLayout);
Vue.component("layout-dashboard", DashboardLayout);
Vue.component("layout-dashboard-rtl", DashboardRTLLayout);

let app;
auth.onAuthStateChanged((user) => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  }
  if (user) {
    store.dispatch("getVotes");
    store.dispatch("getVoters");

    store.dispatch("fetchUserProfile", user);
  }
  store.dispatch("getVoters");
  store.dispatch("getCandidates");
  store.dispatch("getGovernors");
  store.dispatch("getSenators");

});